import { attendanceServiceApi } from "../../app/attendanceServiceApi";
import { API_URL } from "../../constants/apiUrl";
import { GetQueryArgsType } from "../../types";
import {
  GetAttendanceSettingDataResponseType,
  GetOfficeSettingDataResponseType,
  GetSelectedEmployeesResponseType,
  GetSettingLogResponseType,
  GetUnpaidLeavePolicyResponseType,
  ViewSelectedUserParams,
} from "../../types/attendance";

export const attendanceSettingApi = attendanceServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    getOfficeSettingData: builder.query<
      GetOfficeSettingDataResponseType,
      unknown
    >({
      query: () => ({
        url: API_URL.getOfficeSettingData,
      }),
      providesTags: ["GetOfficeSettingData"],
    }),
    addOfficeSetting: builder.mutation({
      query: (data) => ({
        url: API_URL.addOfficeSetting,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["GetOfficeSettingData", "GetSelectedEmployees"],
    }),
    getAttendanceSettingData: builder.query<
      GetAttendanceSettingDataResponseType,
      any
    >({
      query: () => ({
        url: API_URL.getAttendanceSettingData,
      }),
      providesTags: ["GetAttendanceSettingData"],
    }),
    addAttendanceSetting: builder.mutation({
      query: (data) => ({
        url: API_URL.addAttendanceSetting,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["GetAttendanceSettingData"],
    }),
    createUnpaidPolicy: builder.mutation({
      query: (data) => ({
        url: API_URL.createUnpaidPolicy,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["GetUnpaidLeavePolicy"],
    }),
    getUnpaidLeavePolicy: builder.query<GetUnpaidLeavePolicyResponseType, void>(
      {
        query: () => ({
          url: API_URL.getUnpaidLeavePolicy,
        }),
        providesTags: ["GetUnpaidLeavePolicy"],
      }
    ),
    getOfficeSettingLog: builder.query<GetSettingLogResponseType, any>({
      query: (params) => ({
        url: API_URL.getOfficeSettingLog,
        params,
      }),
    }),
    getSelectedEmployees: builder.query<
      GetSelectedEmployeesResponseType,
      GetQueryArgsType<ViewSelectedUserParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getSelectedEmployees,
        ...queryArgs,
      }),
      providesTags: ["GetSelectedEmployees"],
    }),
  }),
});

export const {
  useGetOfficeSettingDataQuery,
  useAddOfficeSettingMutation,
  useGetAttendanceSettingDataQuery,
  useAddAttendanceSettingMutation,
  useCreateUnpaidPolicyMutation,
  useGetUnpaidLeavePolicyQuery,
  useGetOfficeSettingLogQuery,
  useGetSelectedEmployeesQuery,
} = attendanceSettingApi;
